import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, InfoIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { Reward } from '../../types/family';
import { Sheet } from '../ui/Sheet';
import { Button } from '../ui/Button';
import { Chip, Field } from '../ui/Form';
const slots = ['Sobota 10. 10., filmski večer', 'Nedelja 11. 10. popoldne', 'Naslednji dogovorjen termin igranja'];
export function RewardRequestSheet({
  reward,
  onClose
}: {
  reward: Reward | null;
  onClose: () => void;
}) {
  const {
    family,
    viewer,
    balanceOf,
    requestReward
  } = useAppState();
  const [slot, setSlot] = useState(slots[0]);
  useEffect(() => setSlot(slots[0]), [reward]);
  const eligible = family.lastWeekReached[viewer.id];
  return <Sheet open={Boolean(reward)} onClose={onClose} title={reward?.title ?? ''} subtitle={`${reward?.cost ?? 0} goodies · stanje ${balanceOf(viewer.id)}`} footer={<Button variant="bonus" className="w-full" disabled={!slot.trim()} onClick={() => {
    if (reward) requestReward(reward.id, slot.trim());
    onClose();
  }} data-id="element-352" data-mp="3s0fbpogu6pdm">
          Pošlji zahtevo
        </Button>} data-id="element-351" data-mp="1xqldeoeufsri">
      <div className="space-y-4" data-id="element-353" data-mp="36g3en90ct50d">
        <div data-id="element-354" data-mp="32bvlmzmv52wc">
          <p className="mb-1.5 text-sm font-bold" data-id="element-355" data-mp="32dgf0lxfyfsm">Termin</p>
          <div className="flex flex-wrap gap-2" data-id="element-356" data-mp="2emt4ru01ze2w">
            {slots.map(s => <Chip key={s} active={slot === s} onClick={() => setSlot(s)} data-id="element-357" data-mp="2eox92d1v6f3p">
                {s}
              </Chip>)}
          </div>
        </div>
        <Field label="Ali vpiši svoj termin" data-id="element-358" data-mp="2nok7cpzar4sj">{id => <input id={id} className="field" value={slot} onChange={e => setSlot(e.target.value)} data-id="element-359" data-mp="2nl4t1pdg5zs6" />}</Field>
        <p className={`flex items-start gap-2 rounded-2xl p-3 text-sm ${eligible ? 'bg-done-soft text-done-ink' : 'bg-review-soft text-review-ink'}`} data-id="element-360" data-mp="2xa12w7ksg67">
          {eligible ? <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-361" data-mp="3u31nplm59ao9" /> : <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-362" data-mp="2rp3ubl0a4lzd" />}
          {eligible ? 'Pogoj je izpolnjen: v zadnjem zaključenem tednu si naredil(a) kačing.' : 'V zadnjem zaključenem tednu prag ni bil dosežen. Zahtevo lahko pošlješ, starš pa presodi o izjemi.'}
        </p>
        <p className="text-xs text-muted" data-id="element-363" data-mp="35on2uex05zc7">Točke se odštejejo enkrat, ob starševski odobritvi. Poznejše koriščenje jih ne odšteje znova.</p>
      </div>
    </Sheet>;
}